const styles = () => ({
  container: {
    backgroundColor: 'rgb(249, 249, 249)',
    display: 'flex',
    justifyContent: 'space-between'
  }
});

export default styles;